module.exports = __webpack_public_path__ + "img/samuel-zeller-118195.91772f85.jpg";